import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	dismissTicketAiSuggestedActionMutation,
	DismissTicketAiSuggestedActionInput,
} from './__generated__/dismissTicketAiSuggestedActionMutation.graphql';

const mutation = graphql`
	mutation dismissTicketAiSuggestedActionMutation($input: DismissTicketAiSuggestedActionInput!) {
		dismissTicketAiSuggestedAction(input: $input) {
			clientMutationId
			ticket {
				id
				...AiSuggestedActionsList_ticket
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: DismissTicketAiSuggestedActionInput,
	onCompleted?: (r: dismissTicketAiSuggestedActionMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<dismissTicketAiSuggestedActionMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'dismissTicketAiSuggestedActionMutation'};
